import { VIDEO_RESOURCES_ADMIN_ROUTES } from '../shared/utils/routes'
import createAppRouter from './create_router'

const videoResourcesRouter = createAppRouter(VIDEO_RESOURCES_ADMIN_ROUTES, {
  redirect: true,
  history: true,
})

export default videoResourcesRouter
